import { Layout } from "@/components/Layout";
import { Seo } from "@/components/Seo";
import { useSettings } from "@/context/SettingsContext";
import { ContactCards } from "@/components/ContactItems";

export default function Contact() {
  const { settings } = useSettings();
  return (
    <Layout>
      <Seo title="Contact Mashiniya | Indra Sphere" description="Get in touch with the Mashiniya team. Call or email us to list your machine or ask about used machines, new machines and spare parts across India." canonical={window.location.origin + "/contact"} />
      <div className="border-b border-slate-200 bg-white">
        <div className="mx-auto max-w-7xl px-4 py-10 sm:px-6 lg:px-8">
          <h1 className="font-display text-3xl font-extrabold text-slate-900 sm:text-4xl">Contact Us</h1>
          <p className="mt-1 text-slate-500">Get in touch with the Mashiniya team.</p>
        </div>
      </div>
      <div className="mx-auto max-w-4xl px-4 py-14 sm:px-6 lg:px-8">
        <ContactCards />
        <div className="mt-8 rounded-2xl bg-slate-900 p-8 text-center text-white">
          <h2 className="font-display text-2xl font-bold">Have a machine to sell?</h2>
          <p className="mt-2 text-slate-300">Share your machine details and our team will contact you.</p>
          <a href="/sell-your-machine" className="mt-5 inline-flex rounded-full bg-brand px-6 py-3 text-sm font-bold text-white">SELL YOUR MACHINE</a>
        </div>
      </div>
    </Layout>
  );
}
